import { SupportedLanguageCodes, MainAppLanguage } from './SupportedLanguageCodes';

/**
 * Re-export the supported language codes to keep things tidy.
 */
export { SupportedLanguageCodes };

/**
 * Re-export the main app language to keep things tidy.
 */
export { MainAppLanguage };

/**
 * Type representing the supported language code values (e.g., "en", "es")
 */
export type SupportedLanguageCode = (typeof SupportedLanguageCodes)[keyof typeof SupportedLanguageCodes];

/**
 * Labels for the supported languages.
 * When adding a new language, make sure to add the label is written in the language itself.
 */
export const SupportedLanguageLabels: Record<SupportedLanguageCode, string> = {
    [SupportedLanguageCodes.English]: 'English',
    [SupportedLanguageCodes.Spanish]: 'Español',
    [SupportedLanguageCodes.Chinese]: '中文',
    [SupportedLanguageCodes.French]: 'Français',
    [SupportedLanguageCodes.Vietnamese]: 'Tiếng Việt',
};

/**
 * Checks if a language is supported.
 *
 * @param language - The language to check.
 * @returns true if the language is supported, false otherwise.
 */
export const IsSupportedLanguage = (language: string): language is SupportedLanguageCode =>
    Object.values(SupportedLanguageCodes).includes(language as SupportedLanguageCode);
